module.exports = __webpack_public_path__ + "img/circle-chevron-right.feca482e.svg";